import {DropType} from '../../grpc_client/grips/protos/shared/drop';
import {DROP_PATH_TO_TYPE_MAP} from '../../pages/Drops/utils/constants';
import useDropTypeFromPath from './useDropTypeFromPath';

type DropSourceType = 'individual' | 'all';

export const useDropSourceFromDrop = (subscriptionType: DropSourceType) => {
  const dropType = DROP_PATH_TO_TYPE_MAP[useDropTypeFromPath()];

  switch (dropType) {
    case DropType.DROP_TYPE_AY_LABEL: {
      return `AYLabelOverview_${subscriptionType}`;
    }
    case DropType.DROP_TYPE_SHOE: {
      return `SneakerReleaseOverview_${subscriptionType}`;
    }
    case DropType.DROP_TYPE_AY_PREMIUM: {
      return `Premium_${subscriptionType}`;
    }
  }

  return '';
};
